const finite = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
};

export function weightedCriteriaAverage(criteria) {
    const rows = (criteria || [])
        .map((item) => {
            const score = finite(item?.computed_score);
            const weight = finite(item?.criteria?.weight ?? item?.weight);
            if (score == null || weight == null || weight <= 0) return null;
            return { score, weight };
        })
        .filter(Boolean);
    if (!rows.length) return null;
    const weightSum = rows.reduce((sum, row) => sum + row.weight, 0);
    if (!weightSum) return null;
    return (
        rows.reduce((sum, row) => sum + row.score * row.weight, 0) / weightSum
    );
}

export function combinedOverallAverage(weightedAverage, overallScore) {
    const overall = finite(overallScore);
    if (weightedAverage == null || overall == null || overall <= 0) return null;
    return weightedAverage * 0.5 + overall * 0.5;
}
